<div class="daily-payment-method-report-wrapper">
  @if (!hideInput) {
    <h2>Dagsrapport - betalmetod</h2>
  }
  @if (hideInput) {
    <h3>Dagsrapport - betalmetod</h3>
  }

  <!-- Datepicker -->
  @if (!hideInput) {
    <div class="date-and-export">
      <mat-form-field>
        <mat-label>Välj period</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Startdatum" [formControl]="from">
          <input matEndDate placeholder="Slutdatum" [formControl]="to">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <button (click)="downloadReport()" class="button slim secondary"
        title="Exportera till CSV">Exportera<mat-icon>save_alt</mat-icon></button>
      </div>
    }

    <!-- Table -->
    @if (paymentMethodReport) {
      <div class="report-table-scroll" tabindex="0" role="region"
        aria-label="Tabell för dagsrapport per betalmetod">
        <table mat-table [dataSource]="paymentMethodReport">
          <ng-container matColumnDef="article">
            <th mat-header-cell *matHeaderCellDef>Betalmetod</th>
            <td mat-cell *matCellDef="let report">{{report.article}}</td>
            <td mat-footer-cell *matFooterCellDef>@if (paymentMethodReport.length) {
              <span>Total</span>
            } </td>
          </ng-container>
          <ng-container matColumnDef="payments">
            <th mat-header-cell *matHeaderCellDef class="number-data">Betalningar</th>
            <td mat-cell *matCellDef="let report" class="number-data">{{report.payments | number: "1.0-0"}} kr</td>
            <td mat-footer-cell *matFooterCellDef class="number-data">{{getTotalByType('payments') | number:
              "1.0-0"}} @if (paymentMethodReport.length) {
              <span>kr</span>
            }</td>
          </ng-container>
          <ng-container matColumnDef="refunds">
            <th mat-header-cell *matHeaderCellDef class="number-data">Återköp</th>
            <td mat-cell *matCellDef="let report" class="number-data">{{report.refunds | number: "1.0-0"}} kr</td>
            <td mat-footer-cell *matFooterCellDef class="number-data">{{getTotalByType('refunds') | number:
              "1.0-0"}} @if (paymentMethodReport.length) {
              <span>kr</span>
            }</td>
          </ng-container>
          <ng-container matColumnDef="brutto">
            <th mat-header-cell *matHeaderCellDef class="number-data">Total (inkl. moms)</th>
            <td mat-cell *matCellDef="let report" class="number-data">{{report.brutto | number: "1.0-0"}} kr</td>
            <td mat-footer-cell *matFooterCellDef class="number-data">{{getTotalByType('brutto') | number: "1.0-0"}}
              @if (paymentMethodReport.length) {
                <span>kr</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="netto">
            <th mat-header-cell *matHeaderCellDef class="number-data">Netto</th>
            <td mat-cell *matCellDef="let report" class="number-data">{{report.netto | number: "1.0-0"}} kr</td>
            <td mat-footer-cell *matFooterCellDef class="number-data">{{getTotalByType('netto') | number: "1.0-0"}}
              @if (paymentMethodReport.length) {
                <span>kr</span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="vat">
            <th mat-header-cell *matHeaderCellDef class="number-data">Moms</th>
            <td mat-cell *matCellDef="let report" class="number-data">{{report.vat | number: "1.0-0"}} kr</td>
            <td mat-footer-cell *matFooterCellDef class="number-data">{{getTotalByType('vat') | number: "1.0-0"}}
              @if (paymentMethodReport.length) {
                <span>kr</span>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['article', 'payments', 'refunds', 'brutto', 'netto', 'vat']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['article', 'payments', 'refunds', 'brutto', 'netto', 'vat']">
          </tr>
          <tr mat-footer-row *matFooterRowDef="['article', 'payments', 'refunds', 'brutto', 'netto', 'vat']"></tr>
        </table>
      </div>
    }

    <!-- Empty set info -->
    @if ((paymentMethodReport?.length || 0) <= 0) {
      <div class="{{!errorMessage ? 'empty-content' : 'error-content'}}">
        <p>{{errorMessage ? 'Någonting gick fel, kunde inte hämta data för den valda perioden.' :
        'Det finns inga data för den valda perioden.'}}</p>
      </div>
    }
  </div>